import { useState, useContext, useEffect} from 'react';
import { Container, TextField, Button, Typography, Alert } from '@mui/material';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import AuthContext from '../AuthContext';
import { apiFetch } from '../api';
import { useLocation } from 'react-router-dom';

export default function LoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const element = document.getElementById(location.hash.substring(1));
      if (element) {
        setTimeout(() => {
          const navbarHeight = 80; // Approximate navbar height
          const elementPosition = element.getBoundingClientRect().top + window.scrollY;
          window.scrollTo({
            top: elementPosition - navbarHeight,
            behavior: 'smooth'
          });
        }, 100);
      }
    } else {
      // Always scroll to top when there's no hash
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  }, [location]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    try {
      const response = await apiFetch('/api/auth/login/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      });

      // Add debugging logs
      console.log('Response status:', response.status);
      const data = await response.json();
      console.log('Response data:', data);
      
      if (!response.ok) {
        throw new Error('Invalid credentials');
      }

      // persist the entered username so other pages can read it
      localStorage.setItem('username', username);

      // if your AuthContext login supports receiving user info, pass it
      try {
        login(data.token, { username });
      } catch (e) {
        login(data.token);
      }
      navigate('/dashboard');
    } catch (err) {
      console.error('Login error:', err);
      setError(err.message);
    }
    //   const data = await response.json();
    //   login(data.token);
    //   navigate('/dashboard');
    // } catch (err) {
    //   setError(err.message);
    // }
  };

  return (
    <div style={{            
      backgroundColor: '#000000ff',
      minHeight: '100vh',
      paddingTop: '80px',
    }}>
      <Container sx={{ py: 4 }} maxWidth="sm">
        <Typography
          variant="h4" component="h1" gutterBottom
          style={{ color: '#fff', fontFamily: 'Inter, sans-serif', fontSize: '3rem', fontWeight: 500, textAlign: 'center' }}>
          Login
        </Typography>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        <form onSubmit={handleSubmit}>
          <TextField            
            label="Username/Email"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            fullWidth
            margin="normal"
            required
            sx={{
              '& .MuiInputLabel-root': {
                color: '#fff',
                '&.Mui-focused': { color: '#fff' }
              },
              '& .MuiOutlinedInput-root': { 
                color: '#fff',
                '& fieldset': { borderColor: '#fff' },
                '&:hover fieldset': { borderColor: '#fff' },
                '&.Mui-focused fieldset': { borderColor: '#fff' }
              }
            }}
          />
          <TextField
            label="Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            fullWidth
            margin="normal"
            required
            sx={{
              '& .MuiInputLabel-root': {
                color: '#fff',
                '&.Mui-focused': { color: '#fff' }
              },
              '& .MuiOutlinedInput-root': { 
                color: '#fff',
                '& fieldset': { borderColor: '#fff' },
                '&:hover fieldset': { borderColor: '#fff' },
                '&.Mui-focused fieldset': { borderColor: '#fff' }
              }
            }}
          />
          <Button variant="contained"
           type="submit"
           sx={{ 
              mt: 2,
              backgroundColor: '#fff',
              color: '#000',
              '&:hover': {
                backgroundColor: '#f0f0f0'
              }
            }}
          >
            Login
          </Button>
        </form>
        <Button
         sx={{
             mt: 4,
             mr: 2,
             backgroundColor: '#000000ff',
             color: '#ffffffff',
             '&:hover': {
                backgroundColor: '#000000ff'
              }
          }}
         component={RouterLink} to="/signup">
          Need an account? Sign up
        </Button>
        <Button
         sx={{
           mt: 4,
           ml: 2,
           backgroundColor: '#000000ff',
             color: '#ffffffff',
             '&:hover': {
                backgroundColor: '#000000ff'
              }
         }}
         component={RouterLink} to="/reset">
          Forgot password?
        </Button>
      </Container>
    </div>
  );
}
